<template>
  <div class="photo-item">
    <div class="cropper-wrapper">
      <PhotoCropper
        ref="cropper"
        :image-url="image && image.url"
        :image-loader="loadingImage"
        :file="file"
        :show-delete="showDelete"
        @upload-image="$emit('upload-image', $event)"
        @upload-many-images="$emit('upload-many-images', $event)"
      />
    </div>

    <div class="photo-item__wrapper">
      <div class="photo-item__categories-wrapper">
        <v-select
          v-model="chosenMediaType"
          :items="mediaTypes"
          :menu-props="{
            bottom: true,
            offsetY: true
          }"
          append-icon="mdi-chevron-down"
          :label="$t('message.common.category')"
          item-text="name"
          hide-details
          return-object
          class="photo-item__categories-select"
          @change="$emit('media-type-change', chosenMediaType)"
        >
        </v-select>
        <v-tooltip right :max-width="436">
          <template v-slot:activator="{ on }">
            <div class="info-icon mt-3" v-on="on">
              <v-icon color="accent">mdi-information</v-icon>
            </div>
          </template>
          {{ $t("message.photos.categoriesTooltip") }}
        </v-tooltip>
      </div>
      <v-btn
        v-if="showDelete"
        icon
        color="pink"
        @click="$emit('delete-image')"
        class="photo-item__delete"
      >
        <v-icon>
          icon-trash
        </v-icon>
      </v-btn>

      <InfoBox is-html :text="$t('message.photos.addPhotoTooltip')" />
    </div>
  </div>
</template>

<script>
import PhotoCropper from "@/components/Photos/Cropper.vue";
import InfoBox from "@/components/ui/InfoBox.vue";
export default {
  name: "PhotoAddItem",
  components: {
    PhotoCropper,
    InfoBox
  },
  props: {
    image: {
      type: Object,
      default: null
    },
    loadingImage: {
      type: Boolean,
      default: false
    },
    mediaTypes: {
      type: Array,
      default: () => []
    },
    file: {
      type: File,
      default: null
    },
    showDelete: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      chosenMediaType: null
    };
  }
};
</script>

<style lang="scss" scoped>
.photo-item {
  border: 1px solid $primary-light;
  border-radius: 16px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  position: relative;

  &__wrapper {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
    padding: $spacing * 3;
  }

  &__delete {
    position: absolute;
    top: $spacing * 3;
    right: $spacing * 3;
  }

  &__categories {
    &-wrapper {
      display: flex;
      align-items: center;
      max-width: 420px;
    }

    &-select {
      width: 100%;
      margin-right: $spacing;
    }
  }
}

.cropper-wrapper {
  min-width: 200px;
  height: 200px;
  display: flex;
}
</style>
